import { ReactElement } from "react";
import { CatTabPanel } from '@blocks-react/components/TabPanel';

interface MyEquipmentTabPanelProps {
  children: ReactElement | string;
}

export const MyEquipmentTabPanel = ({
  children
}: MyEquipmentTabPanelProps) => {
  return (
    <CatTabPanel slot="panel" className="mt-3" skipFocusOnPanel>
      {children}
    </CatTabPanel>
  );
};
